import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import NiceModal from '@ebay/nice-modal-react'
import CustomModal from 'components/NiceModal'
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './redux/store'
import I18nWrapper from './configs/i18n'
import { Toaster } from 'react-hot-toast'
import themeConfig from './configs/themeConfig';
import Spinner from 'components/spinner/Fallback-spinner'
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import LanguageSwitcher from 'components/LanguageSwitcher/LanguageSwitcher';
import CountrySwitcher from 'components/CountrySwitcher/CountrySwitcher';
import ScrollToTop from 'components/ScrollToTop';
import 'styles/CustomStyles.scss'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

NiceModal.register('M17', CustomModal)
NiceModal.register('M172', CustomModal)
const container = document.getElementById('root')
const root = createRoot(container)

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: true,
      refetchOnReconnect: false,
      retry: false
    }
  }
})

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <NiceModal.Provider>
        <PersistGate loading={null} persistor={persistor}>
          <I18nWrapper>
            <Suspense fallback={<Spinner />}>
              <LanguageSwitcher/>
              <CountrySwitcher/>
              <ScrollToTop/>
              <LazyApp />
              <Toaster position={themeConfig.layout.toastPosition} toastOptions={{ className: 'react-hot-toast' }} />
            </Suspense>
          </I18nWrapper>
        </PersistGate>
      </NiceModal.Provider>
    </Provider>
  </QueryClientProvider>
)